<template>
  <el-card shadow="never">
    <el-row :gutter="20">
      <el-col :span="8">
        <FormItem :label="$t('analysesData.sampleSymLotBulk.analysisCode')">
          <el-input
            v-model="aggregatedAnalysisCode"
            disabled
          />
        </FormItem>
      </el-col>
      <el-col :span="8">
        <FormItem :label="$t('analysesData.sampleSymLotBulk.analysis')">
          <el-input
            v-model="aggregatedAnalysisDescription"
            disabled
          />
        </FormItem>
      </el-col>
      <el-col :span="24">
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="$t('analysesData.sampleSymLotBulk.details')"
            name="1"
          >
            <template v-if="activeNames.includes('1')">
              <el-row
                :gutter="20"
                v-for="key in sampleValueKeys"
                :key="key"
              >
                <el-col :span="6">
                  <FormItem :label="$t('analysesData.sampleSymLotBulk.sample')">
                    <el-input
                      :value="sampleValue[key].labSampleCode"
                      disabled
                      v-once
                    />
                  </FormItem>
                </el-col>
                <el-col :span="6">
                  <FormItem :label="$t('operations.create.symbolType')">
                    <el-input
                      :value="getSymbolTypeLabel(sampleValue[key].symbolType)"
                      disabled
                      v-once
                    />
                  </FormItem>
                </el-col>
                <el-col :span="6">
                  <FormItem :label="$t('analysesData.sampleSymLotBulk.symbol')">
                    <AutocompleteSymbol v-model="sampleValue[key].symbol" />
                  </FormItem>
                </el-col>
                <el-col :span="6">
                  <FormItem :label="$t('analysesData.sampleSymLotBulk.lot')">
                    <el-input v-model="sampleValue[key].symbolLot" />
                  </FormItem>
                </el-col>
              </el-row>
            </template>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
  import FormItem from '@/components/FormItem.vue';
  import { SymbolTypes } from '@/config/constants';
  import AutocompleteSymbol from '@/components/AutocompleteSymbol.vue';

  export default {
    name: 'SampleSymLotBulk',
    components: {
      FormItem,
      AutocompleteSymbol,
    },
    props: {
      value: { type: Array, required: true },
      cardKey: { type: String, required: true },
      isOpen: { type: Boolean, default: false },
    },
    data() {
      return {
        aggregatedAnalysisCode: '',
        aggregatedAnalysisDescription: '',
        lot: '',
      };
    },
    computed: {
      symbolTypes() {
        return Object.values(SymbolTypes).map((val) => ({
          value: val,
          label: this.$t(`enums.symbolTypes.${val}`),
        }));
      },
      sampleValue() {
        return this.value;
      },
      sampleValueKeys() {
        return Object.keys(this.sampleValue);
      },
      activeNames: {
        get() {
          return this.isOpen ? ['1'] : [];
        },
        set(val) {
          const isOpen = val.includes('1');
          this.$emit('toggle-collapse', this.cardKey, isOpen);
        },
      },
    },
    watch: {
      lot(newVal) {
        const operationValues = this.sampleValue.map((item) => ({
          ...item,
          symbolLot: newVal,
        }));
        this.$emit('input', operationValues);
      },
    },
    methods: {
      getSymbolTypeLabel(symbolType) {
        if (!symbolType) return '';
        return this.$t(`enums.symbolTypes.${symbolType}`);
      },
    },
    created() {
      this.aggregatedAnalysisCode = this.sampleValue[0].analysisCode;
      this.aggregatedAnalysisDescription =
        this.sampleValue[0].analysisDescription;
    },
  };
</script>

<style lang="scss">
  .el-card {
    background-color: transparent;
    border: transparent;
  }
</style>
